import { render, staticRenderFns } from "./FooterGreen.vue?vue&type=template&id=33bf6ce5&scoped=true&"
import script from "./FooterGreen.vue?vue&type=script&lang=js&"
export * from "./FooterGreen.vue?vue&type=script&lang=js&"
import style0 from "./FooterGreen.vue?vue&type=style&index=0&id=33bf6ce5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf6ce5",
  null
  
)

component.options.__file = "FooterGreen.vue"
export default component.exports